<template>
  <div id='' class='gPageBorder' v-loading='loading'>


    <div id=''>
      <div style=''>

        <el-row :gutter="20" class="grow">
          <el-col :span="4" >
            <el-button  type='' @click='exportF'>{{$t('app_export')}}</el-button>            
          </el-col>
          <el-col :span="4">
            <div >
              <el-input  :placeholder="$t('app_mechno')" v-model='qmcid' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div >
              <el-input  :placeholder="$t('app_terNo')" v-model='qtnid' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div >              
              <el-select @change="query" style='width:100%' v-model="qtype" clearable :placeholder="$t('app_trdtype')">
                <el-option
                  v-for="item in types"
                  :key="item.vl"
                  :label="item.tt"
                  :value="item.vl">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="4">
            <div >
              <el-input  :placeholder="$t('app_trdno')" v-model='qtrid' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>
          <el-col :span='4'>
            <div >
              <el-input  placeholder="SN" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>
        </el-row>


      </div>
    </div>


    <!-- <div id='adFilter' v-show=0>
      <label>{{$t('app_filter')}}:</label>
      <el-select style='width:16%;margin-left:20px;' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
        <el-option
          v-for="item in appTypes"
          :key="item.appClassifyId"
          :label="item.appClassifyName"
          :value="item.appClassifyId">
        </el-option>
      </el-select>
      <el-select style='width:16%;margin-left:20px;' v-model="appStatusValue" clearable :placeholder="$t('app_status')">
        <el-option
          v-for="item in appStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->

    <div id=''>
      <el-table
        @row-click='cellClick'
        :data="tableData"
        border
        @sort-change="sortChange"
        class='gTopMg'
        style="width: 100%;border:none;">

        <el-table-column
          header-align='center'
          align='center'
          prop="terminalNo"
          :label="$t('app_deviceNo')"
          width="100">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="accountNo"
          width=''
          :label="$t('app_account')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="traceId"
          width='115'
          :label="$t('app_tradeNo')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="batchId"
          width='120'
          :label="$t('app_batcno')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="amout"
          width=''
          :label="$t('app_amout')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="merchId"
          width=''
          :label="$t('app_mechno')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          ssortable="custom"
          prop="requesTime"
          width='176'
          :label="$t('app_trdtime')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="requestDate"
          width='100'
          :label="$t('app_trddate')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="hostagentserialNo"
          width='100'
          :label="$t('app_coretrans')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="referenceNo"
          width='100'
          :label="$t('app_expno')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="authRc"
          width='100'
          :label="$t('app_terNo')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="authRc"
          width='100'
          :label="$t('app_trdtype')">
          <template slot-scope='scope'>
            {{typest[scope.row.transType]}}
          </template>
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          sortable="custom"
          prop="recordTime"
          width='176'
          :label="$t('app_opetime')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="operate"
          width='86'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            <span style='background:none;'>
            <el-tooltip class="item" effect="dark" :content="$t('app_preview')" placement="top">
              <el-button v-show="true" type=text @click='viewpic(scope.row)'><i class="fa fa-file-image-o" style=""></i></el-button>
            </el-tooltip>
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
              <el-button v-show="scope.row.status == 0 || scope.row.status == 3" @click='submitApp(scope.row)' type='text'><i class="fa fa-external-link-square" style=""></i></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top" v-show='true'>
              <el-button type='text' @click='deleteApp(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip> -->
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>
        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<style>
  /* html,body{width:100%;height:100%;}*/

  .tbPoint td{cursor:pointer}

  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}

  #appDepot{min-width:840px;}

  #adData{}



</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import mm from 'moment'
  export default{
    components: {
      MechanismSelector
    },
    data () {
      var that = this
      return {
        qmcid: '',
        qtnid: '',
        qtype: '',
        qtrid: '',
        orderName: '',
        orderType: '',
        mechanismData: {
          callback (value) {
            that.mech = value
            that.selectChange(value)
          }
        },
        listKey: 'launch-list',

        dvLoading: 0,
        appId: '',
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'}
        ],
        typest: {
          '116': this.$t('app_getcash'),
          '122': this.$t('app_lctrans'),
          '123': this.$t('app_obtrans'),
          '154': this.$t('app_phontrs')
        },
        types: [
          {tt: this.$t('app_getcash'),vl: '116'},
          {tt: this.$t('app_lctrans'),vl: '122'},
          {tt: this.$t('app_obtrans'),vl: '123'},
          {tt: this.$t('app_phontrs'),vl: '154'},
        ],
        channels: [],
        srchValue: '',
        channelId: '',
        cerTipMsg: '',
        status: '',
        dvIndex: 1,
        dialogVisible: 0,
        mechanismId: window.localStorage['mechanismId'],
        selectMid: '',
        tableData: [],
        dvTableData: [],
        appTypes: [],
        appTypeValue: '',
        appStatus: [
          {label: this.$t('app_prePushVerify'), value: '0'},
          {label: this.$t('app_preVerify'), value: '1'},
          {label: this.$t('app_verifyPass'), value: '2'},
          {label: this.$t('app_verifyNotPass'), value: '3'}],
        appStatusValue: '',
        total: 0,
        index: 1,
        dvTotal: 0,
        loading: 0,
        appType: '',
        queryKey: ''
      }
    },
    computed: {

      getDvStatus (value) {
        switch (value) {
          case '0':
            return this.$t('app_prePushVerify')
          case '1':
            return this.$t('app_preVerify')
          case '2':
            return this.$t('app_verifyPass')
          case '3':
            return this.$t('app_verifyNotPass')
        }
      }
    },
    methods: {
      viewpic (row) {
        window.open(this.$host+row.faceUrl, '_blank')
      },
      sortChange (vl) {
        switch (vl.prop) {
          case 'createTime':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList()
      },
      pushCreateCer () {
        this.$router.push({path: "/certificate/new"})
      },
      pushUploadCer () {
        this.$router.push({path: "/certificate/upload"})
      },
      bindOperate (row) {
        //console.log(row)

        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          // console.log(localStorage.mechanismId, tNo)
          this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
      },
      getChannels () {
        this.$getChannelList(10000, 1, '', '', '', (res) => {
          if (res.status === 200) {
            this.channels = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      srchDevice () {
        this.getDevices()
      },
      selectDvChange (vl) {
        this.getDevices()
      },
      pageDvSized (val) {
        this.$gRow = val
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var appId = this.appId ? this.appId : ''
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, (res) => {
            // console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {

          this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, (res) => {
            console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        }

      },
      editApp (row) {
        this.$setWObj('dvconfigEdit', row.id)
        this.$router.push({path: '/dvconfig/edit'})
      },
      pushApp (row) {


        this.$setWObj('pushList', {type: '13', data: row})
        this.$router.push({path: '/stfile/push'})

      },
      query () {
        this.page = 1
        this.getList()
      },
      selectChange (vl) {
        this.selectMid = vl
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      pageSelect (index) {
        this.index = index
        this.getList()
      },
      pageDvSelect (index) {
        this.dvIndex = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      deleteApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.$delTc(obj.id, res => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      submitApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$verifyFst(obj.recordId, '', '1', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })

        }, '')
      },
      cellClick (row, ev, col) {
        // if (col.label && col.label === this.$t('app_operate')) {
        //   return
        // }
        // this.$setWObj('dvconfigDetail', row.id)
        // this.$router.push({path: '/dvconfig/detail'})
      },
      exportF () {
        var sn = this.queryKey ? this.queryKey : ''
        var mcID = this.qmcid
        var termID = this.qtnid
        var type = this.qtype
        var trId = this.qtrid
        this.$exportTrans(mcID, termID, type, trId, sn)
      },
      getList () {
        this.loading = 1
        // var dsid = this.selectMid ? this.selectMid : '' //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        var mcID = this.qmcid
        var termID = this.qtnid
        var type = this.qtype
        var trId = this.qtrid
        this.$translist(this.index, this.$gRow, name, '', mcID, termID, type, trId, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      setInstallType (type) {
        return this.$installType[type]
      }
    },
    mounted () {
      ///// 检查添加做的跳转
      var jid = this.$getWObj().sdjumpId
      if (jid) {
        this.$setWObj('dvconfigDetail', jid)
        this.$router.push({path: '/dvconfig/detail'})
        this.$setWObj('sdjumpId', '')
      }

      //this.getChannels()
      this.getList()
      /*this.$getAppTypeList(100000000, 1, (res) => {
        if (res.status === 200) {
          this.appTypes = res.data
        } else {
          this.$message(res.message)
        }
      }, '')*/
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?f7122486